import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundarypage from './404ErrorPage/error-boundarypage.js';

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state to show the fallback UI
		console.log(error);
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		console.error('Error caught by boundary:', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// You can render any fallback UI here
			return <ErrorBoundarypage />;
		}

		// Render children if there's no error
		return this.props.children;
	}
}
ErrorBoundary.propTypes = {
	children: PropTypes.any
};

export default ErrorBoundary;
